// 口语定级测试的题目。朗读按难度各选一句；两道问答从各自的题池里随机抽一道。
export const READ_ALOUD_TIERS = [
  [
    "I usually go to the gym after work, but today I'm too tired.",
    'My favorite place in the city is a small park near my home.',
    'Please leave your shoes by the door and come into the living room.',
    'We need to buy some milk and bread before the shops close.',
    'My sister takes the train to school every morning.',
    'The weather is lovely today, so we can have lunch outside.',
    'I called my friend yesterday, but she was busy at work.',
    'Turn left at the next street and you will see the station.',
    'There is a small table next to the window in my room.',
    'Would you like a cup of tea while you wait for the bus?'
  ],
  [
    'The new library downtown has become a popular place for students to study.',
    'Most people agree that learning a language takes time, patience and practice.',
    'Although the restaurant was crowded, we managed to find a table near the window.',
    'The manager asked everyone to arrive early for the meeting on Thursday.',
    'If the weather improves this weekend, we are planning to go hiking.',
    'She decided to take an evening course to improve her computer skills.',
    'Several passengers missed their connection because the first flight was delayed.',
    'The exhibition includes photographs taken by local artists over the past year.',
    'Before you submit the application, make sure all the information is correct.',
    'Living close to public transport makes it easier to get around the city.'
  ],
  [
    'Despite the initial setbacks, the team eventually managed to deliver the project ahead of schedule.',
    'Researchers suggest that regular exercise can significantly improve both memory and concentration.',
    'The proposal was initially rejected, although further evidence persuaded the committee to reconsider.',
    'Increasing access to reliable information does not necessarily lead to better decisions.',
    'What distinguishes an effective leader is the ability to listen carefully and respond constructively.',
    'The environmental consequences of rapid urban development are becoming increasingly difficult to ignore.',
    'Had the instructions been clearer, the misunderstanding could probably have been avoided.',
    'While technology offers considerable convenience, its benefits are not distributed equally across society.',
    'The research challenges the assumption that productivity always improves when people work longer hours.',
    'Rather than focusing exclusively on short-term results, the organisation adopted a more sustainable approach.'
  ]
]

export const DAILY_QUESTIONS = [
  'Tell me about a typical day in your life.',
  'Describe the place where you live.',
  'What do you like to do on weekends?',
  'Tell me about a friend you spend a lot of time with.',
  'What did you do last weekend?',
  'Tell me about a meal you enjoy and how you usually prepare it.',
  'Describe a place you visited recently. What did you do there?',
  'Tell me about a hobby you would like to try.',
  'How do you usually travel to work or school?',
  'Describe something useful you have learned recently.',
  'Tell me about a book, film or show you enjoyed.',
  'Describe your favourite room at home and how you use it.',
  'What do you usually do when you have a free evening?',
  'Tell me about a time someone helped you.',
  'Describe a shop or market you often visit.',
  'Tell me about a celebration you remember.',
  'What do you do to stay healthy?',
  'Describe something you use every day and explain why it is useful.',
  'Tell me about a small problem you solved recently.',
  'What would you like to do on your next holiday?'
]

export const OPINION_QUESTIONS = [
  'Do you think smartphones make people more lonely? Why or why not?',
  'Is it better to live in a big city or a small town? Why?',
  'Should schools teach practical skills like cooking and managing money? Why?',
  'Do you think working from home will become more common? Why?',
  'What are the advantages and disadvantages of learning online?',
  'Should public transport be free? Why or why not?',
  'Is it better to buy fewer expensive things or more inexpensive things? Why?',
  'Should children be allowed to choose how much time they spend on screens? Why?',
  'Do you think people should change jobs regularly? Why or why not?',
  'Is travelling abroad necessary to understand other cultures? Why?',
  'Should cities provide more space for parks or for housing? Explain your view.',
  'Do you think advertisements help people make better choices? Why or why not?',
  'Should everyone learn a second language? Explain your opinion.',
  'Is learning from experience more useful than learning from books? Why?',
  'Should employers allow flexible working hours? Why or why not?',
  'Do you think repairing old products is better than replacing them? Why?',
  'Should museums charge an entrance fee? Explain your view.',
  'Is competition helpful when people are learning something new? Why?',
  'Should local communities do more to support older people? How and why?',
  'Do you think artificial intelligence will make everyday life better? Explain your view.'
]

export const READ_ALOUD_SECONDS = 15
export const DAILY_SECONDS = 30
export const OPINION_SECONDS = 45
export const PREP_SECONDS = 5
export const ANSWER_PREP_SECONDS = 15

function defaultStorage() {
  try { return window.localStorage } catch { return null }
}

export function buildSpeakingTasks(random = Math.random, storage = defaultStorage(), uid = 'local') {
  const key = `gs.speakingTest.history.${uid}`
  let history = []
  try {
    const saved = JSON.parse(storage?.getItem(key) || '[]')
    if (Array.isArray(saved)) history = saved.filter(item => typeof item === 'string')
  } catch { /* A missing history does not prevent a test. */ }
  const pick = list => {
    const unseen = list.filter(text => !history.includes(text))
    const candidates = unseen.length ? unseen : list.filter(text => history.indexOf(text) === Math.min(...list.map(item => history.indexOf(item))))
    return candidates[Math.floor(random() * candidates.length)]
  }
  const tasks = [
    ...READ_ALOUD_TIERS.map(tier => ({ kind: 'read', text: pick(tier), seconds: READ_ALOUD_SECONDS })),
    { kind: 'answer', text: pick(DAILY_QUESTIONS), seconds: DAILY_SECONDS },
    { kind: 'answer', text: pick(OPINION_QUESTIONS), seconds: OPINION_SECONDS }
  ]
  const selected = tasks.map(task => task.text)
  try { storage?.setItem(key, JSON.stringify([...history.filter(text => !selected.includes(text)), ...selected].slice(-100))) }
  catch { /* Storage can be unavailable in private browsing. */ }
  return tasks
}
